<div class="container" style="width: 97%; margin-top: 1rem">
  <div
    class="row"
    style="margin-bottom: auto; margin-left: auto; margin-right: auto"
  >
    <div class="col-lg-12" style="padding-left: 0px; padding-right: 0px">
      <div
        class="panel panel-primary"
        style="background: #fff; box-shadow: 4px 4px 4px #888888"
      >
        <div class="panel-heading">
          <h4 style="margin-bottom: 3px; margin-top: 5px">
            {{ 'addDCU.title' | translate }}
          </h4>
        </div>

        <div class="panel-body" style="line-height: 9px">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <form
                [formGroup]="addDCUForm"
                #formDirective="ngForm"
                (ngSubmit)="submitDCUDetails()"
                novalidate
              >
                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >{{ 'pleaseSelectSite' | translate
                        }}<span class="iep-required">*</span></mat-label
                      >
                    </div>
                    <div class="col-lg-3 col-sm-3">
                      <mat-form-field>
                        <mat-label>{{
                          'pleaseSelectSite' | translate
                        }}</mat-label>
                        <mat-select
                          formControlName="siteCtr"
                          [(ngModel)]="dcuDetails.siteId"
                          placeholder=""
                          style="top: 12px"
                          (ngModelChange)="siteSelectionChanged($event)"
                          required
                        >
                          <mat-option
                            *ngFor="let item of sites"
                            [value]="item.SiteId"
                          >
                            {{ item.SiteName }}</mat-option
                          >
                        </mat-select>
                        <mat-error
                          *ngIf="isFieldHasError('siteCtr', 'required')"
                          >{{ 'requiredField' | translate }}</mat-error
                        >
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >{{ 'addDCU.DCUMake' | translate
                        }}<span class="iep-required">*</span>
                      </mat-label>
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="dcuMakeCtr"
                          [(ngModel)]="dcuDetails.dcuMake"
                          placeholder="DCU Make"
                          [readonly]="!isSiteSelected"
                          required
                        />
                        <mat-error
                          *ngIf="isFieldHasError('dcuMakeCtr', 'required')"
                        >
                          {{ 'requiredField' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input"
                        >{{ 'addDCU.DCUName' | translate
                        }}<span class="iep-required">*</span>
                      </mat-label>
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="dcuNameCtr"
                          [(ngModel)]="dcuDetails.dcuName"
                          placeholder="DCU Name"
                          (change)="checkDuplicatedDCUName()"
                          [readonly]="!isSiteSelected"
                          required
                        />
                        <mat-error
                          *ngIf="isFieldHasError('dcuNameCtr', 'required')"
                        >
                          {{ 'requiredField' | translate }}
                        </mat-error>
                        <mat-error
                          *ngIf="isFieldHasError('dcuNameCtr', 'duplicated')"
                        >
                          {{ 'addDCU.duplicateDCUName' | translate }}
                          {{ dcuDetails.siteId }}.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input">{{
                        'addDCU.SINumber' | translate
                      }}</mat-label>
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="dcuSerialNumberCtr"
                          [(ngModel)]="dcuDetails.dcuSerialNumber"
                          type="number"
                          placeholder="SI Number"
                          [readonly]="!isSiteSelected"
                        />
                      </mat-form-field>
                    </div>

                    <div class="col-lg-1"></div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-label class="label-input">{{
                        'addDCU.firmWareVersion' | translate
                      }}</mat-label>
                    </div>
                    <div class="col-lg-2 col-sm-2">
                      <mat-form-field>
                        <input
                          matInput
                          formControlName="firmWareVersionCtr"
                          [(ngModel)]="dcuDetails.firmWareVersion"
                          placeholder="FirmWare Version"
                          [readonly]="!isSiteSelected"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-1"></div>
                  <div class="col-lg-5">
                    <div></div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <button
                        bciprimarybutton
                        class="button-primary"
                        type="submit"
                        [disabled]="!addDCUForm.valid || dcuDetails.submitted"
                      >
                        <span>
                          <mat-icon
                            aria-hidden="false"
                            aria-label="weather icon"
                            class="bosch-ic-checkmark-frame"
                            style="width: max-content"
                          >
                          </mat-icon>
                        </span>
                        {{ 'submit' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /.col-lg-12 -->
